export const INITIAL_STATE = {
  getPaymentsCouponProgressLoading: false,
  getPaymentsCouponProgressSuccess: null,
  getPaymentsCouponProgressFailure: null,

  applyPaymentPromoCodeLoading: false,
  applyPaymentPromoCodeSuccess: null,
  applyPaymentPromoCodeFailure: null,

  getPaymentHistory: false,
  getPaymentHistorySuccess: null,
  getPaymentHistoryFailure: null

}
